function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.33,74.123c-0.527-0.602-1.446-0.663-2.048-0.134c-0.604,0.528-0.663,1.446-0.134,2.049l5.242,5.973  c0.436,0.497,1.06,0.789,1.709,0.802c0.016,0,0.03,0,0.045,0c0.637,0,1.252-0.266,1.695-0.732l11.294-11.877  c0.554-0.581,0.529-1.5-0.052-2.053s-1.5-0.529-2.053,0.053L72.164,79.63L67.33,74.123z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.913,63.031h16.261c0.801,0,1.451-0.649,1.451-1.451c0-0.803-0.65-1.452-1.451-1.452H35.913  c-0.802,0-1.452,0.649-1.452,1.452C34.461,62.382,35.111,63.031,35.913,63.031z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.913,31.493h26.905c0.802,0,1.451-0.65,1.451-1.452s-0.649-1.451-1.451-1.451H35.913c-0.802,0-1.452,0.649-1.452,1.451  S35.111,31.493,35.913,31.493z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.913,46.87h26.905c0.802,0,1.451-0.65,1.451-1.452c0-0.801-0.649-1.451-1.451-1.451H35.913  c-0.802,0-1.452,0.65-1.452,1.451C34.461,46.22,35.111,46.87,35.913,46.87z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.49,30.602c0.462,0.692,1.179,1.128,1.965,1.196c0.072,0.006,0.144,0.009,0.215,0.009c0.712,0,1.405-0.304,1.926-0.853  l5.858-6.165c0.553-0.581,0.529-1.5-0.052-2.052c-0.581-0.554-1.499-0.53-2.052,0.052l-5.63,5.924l-1.888-2.831  c-0.445-0.667-1.347-0.848-2.013-0.402c-0.667,0.444-0.848,1.346-0.402,2.013L19.49,30.602z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.489,45.978c0.462,0.694,1.179,1.131,1.966,1.198c0.072,0.006,0.144,0.009,0.215,0.009c0.712,0,1.405-0.304,1.927-0.853  l5.858-6.166c0.552-0.582,0.528-1.5-0.053-2.053c-0.581-0.553-1.5-0.529-2.053,0.053l-5.629,5.926l-1.888-2.833  c-0.445-0.668-1.347-0.849-2.013-0.402c-0.667,0.444-0.848,1.346-0.402,2.013L19.489,45.978z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.489,62.139c0.462,0.693,1.18,1.131,1.966,1.198c0.072,0.007,0.144,0.011,0.216,0.011c0.712,0,1.404-0.306,1.926-0.854  l5.857-6.161c0.553-0.58,0.529-1.5-0.052-2.052c-0.581-0.554-1.499-0.53-2.052,0.052l-5.629,5.92l-1.889-2.832  c-0.445-0.668-1.347-0.848-2.013-0.402c-0.667,0.443-0.848,1.347-0.402,2.014L19.489,62.139z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.701,84.378h43.113C61.055,90.675,67.605,95,75.161,95c10.757,0,19.509-8.751,19.509-19.508  c0-10.438-8.243-18.96-18.557-19.462V14.372c0-5.168-4.203-9.371-9.37-9.371H14.701c-5.167,0-9.371,4.203-9.371,9.371v60.635  C5.33,80.174,9.534,84.378,14.701,84.378z M91.768,75.492c0,9.156-7.449,16.605-16.605,16.605s-16.605-7.449-16.605-16.605  s7.449-16.606,16.605-16.606S91.768,66.336,91.768,75.492z M8.233,14.372c0-3.567,2.901-6.469,6.468-6.469h52.042  c3.565,0,6.468,2.901,6.468,6.469v41.71c-9.845,0.98-17.559,9.313-17.559,19.41c0,2.088,0.338,4.095,0.947,5.982H14.701  c-3.566,0-6.468-2.901-6.468-6.469V14.372z"
});

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.2ca87ff0.svg";
export { ForwardRef as ReactComponent };